<template>
  <section class="image-module-component">
    <img
      rel="preload"
      as="image"
      :src="props.data.module_image_url.url"
      :alt="props.data.module_image_url.alt" />
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ImageComponent",
  "CLASSNAME": "image-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

const props = defineProps(['data'])
</script>

<style lang="scss">
.image-module-component {
  @apply mx-auto w-full max-w-screen-xl px-6 py-24 lg:px-0 lg:py-32;
}
</style>
